import { DEPOT_HOST, CRM_HOST } from '@/constants';

export const DEPOT_API_URL = `${DEPOT_HOST}/api/v1`;
export const CRM_API_URL = CRM_HOST;
